module.exports = __webpack_public_path__ + "img/step3.a966ee1a.png";